export default "__VITE_ASSET__2957756a__"